class ClientServicesLiveChat extends HTMLElement {
  constructor() {
    super();

    const config = {
      timeZone: this.getAttribute('time-zone'),
      weekday: {
        startTime: this.getAttribute('weekday-start'),
        endTime: this.getAttribute('weekday-end'),
      },
      weekend: {
        startTime: this.getAttribute('weekend-start'),
        endTime: this.getAttribute('weekend-end'),
      },
    };

    this.determineStatus(config);
  }

  getCurrentDateTimeInTimeZone(timeZone) {
    const now = new Date();
    const options = {
      timeZone: timeZone,
      timeZoneName: 'short',
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const dateString = formatter.format(now);
    return new Date(dateString);
  }

  determineStatus(config) {
    const timeZone = config.timeZone;

    const weekdayStartTime = config.weekday.startTime;
    const weekdayEndTime = config.weekday.endTime;
    const weekendStartTime = config.weekend.startTime;
    const weekendEndTime = config.weekend.endTime;

    const currentDateTime = this.getCurrentDateTimeInTimeZone(timeZone);
    const day = currentDateTime.getDay();
    const hours = currentDateTime.getHours();
    const minutes = currentDateTime.getMinutes();

    let startTime = weekdayStartTime.split(':').map(Number);
    let endTime = weekdayEndTime.split(':').map(Number);

    if (day === 0 || day === 6) {
      startTime = weekendStartTime.split(':').map(Number);
      endTime = weekendEndTime.split(':').map(Number);
    }

    const startHours = startTime[0];
    const startMinutes = startTime[1];
    const endHours = endTime[0];
    const endMinutes = endTime[1];

    if (
      (hours > startHours || (hours === startHours && minutes >= startMinutes)) &&
      (hours < endHours || (hours === endHours && minutes <= endMinutes))
    ) {
      this.open();
    } else {
      this.closed();
    }
  }

  open() {
    this.classList.add('open');
  }

  closed() {
    this.classList.add('closed');
  }
}

customElements.define('client-services-live-chat', ClientServicesLiveChat);
